<template>
    <Autosuggest
        updateOnSelect
        :value="innerValue"
        :label="config.PROFILE_ADDRESS_COUNTRY"
        :options="filteredCountries"
        @select="onSelect"
        @type="onType"
        @close="onClose"
    />
</template>
<script>
import countries from 'i18n-iso-countries';

import { Autosuggest } from '../lib';
import { SolutionConsumer } from '../../mixins';

export default {
    name: 'CountrySelect',
    components: { Autosuggest },
    mixins: [SolutionConsumer],
    props: {
        value: {
            type: String,
            default: '',
        },
    },
    data () {
        return {
            innerValue: '',
        };
    },
    computed: {
        countries () {
            return Object.entries(countries.getNames(this.language)).map(([isoCode, countryName]) => ({
                name: countryName,
                value: isoCode,
            }));
        },
        filteredCountries () {
            return this.innerValue
                ? this.countries.filter(({ name }) => name.toLowerCase().includes(this.innerValue.toLowerCase()))
                : this.countries;
        },
    },
    watch: {
        value (country) {
            this.innerValue = country ? this.countries.find(({ value }) => value === country).name : '';
        },
    },
    created () {
        // eslint-disable-next-line
        countries.registerLocale(require(`i18n-iso-countries/langs/${this.language}.json`));

        this.innerValue = this.value ? this.countries.find(({ value }) => value === this.value).name : '';
    },
    methods: {
        onType (value) {
            this.innerValue = value;
            this.$emit('input', '');
        },
        onSelect (option) {
            this.innerValue = option.name;
            this.$emit('select', option.value);
        },
        onClose () {
            if (this.innerValue && !this.value) {
                this.innerValue = '';
            }
        },
    },
};
</script>
